import React from 'react';

const CoachAssignmentContext = React.createContext({
  isReady: false,
  currentCoach: null,
  isExternal: false,
});

export default CoachAssignmentContext;
